module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "pokemon-stat-calculator.c37739b7.png" + "?" + Date.now();